<template>
  <ul class="post-comments mb-0 mt-2">
        <li v-for="Comment in Comments" :key="Comment.id">
          <span class="thumb-xs avatar pull-left mr-sm">
            <img class="rounded-circle" src='../../assets/people/a1.jpg' alt="..." />
          </span>
          <div class="comment-body">
            <h6 class="author fs-sm fw-semi-bold">{{getEmployee(Comment.EmployeeID).EmployeeName}}
              <small>{{toMoment(Comment.CreatedAt)}}</small>
            </h6>
            <p class="fs-mini">{{Comment.CommentText}}</p>
          </div>
        </li>
        <li>
          <span class="thumb-xs avatar pull-left mr-sm">
            <img class="rounded-circle" src='../../assets/avatar.png' alt="..." />
          </span>
          <div class="comment-body">
            <textarea-autosize
                  placeholder="Write your comments..."
                  class="form-control"
                  :min-height="75"
                  v-model="commentText"
                />
            <div class="text-md-right mt-sm">
              <b-button variant="success" class="width-100 mb-xs mr-xs" @click="postcomment" :disabled="this.loading">Post</b-button>
            </div>
          </div>
        </li>
      </ul>
</template>

<script>

import { mapState, mapActions } from 'vuex';
import moment from 'moment-timezone';

export default {
  name: 'TaskComments',
  props: ['Comments', 'Employees', 'TaskID'],
  data() {
    return {
      commentText: '',
    }
  },
  methods: {
    ...mapActions('tasks', ['addTaskComment']),
    postcomment() {
      this.addTaskComment({
        taskID : this.TaskID,
        comment: {
          'TaskID'      : this.TaskID,
          'EmployeeID'  : this.userID,
          'CommentText' : this.commentText,
        }
      });
    },

    toMoment(d) {
      return moment(d, "MM/DD/YYYY h:mm:ss a").fromNow();
    },

    getEmployee(id) {
      return this.Employees.find(e => e.id === id);
    }
  },

  computed: {
    ...mapState({
      loading: state => state.alert.loading,
      loaded: state => state.alert.loaded,
      userID: state => state.alert.userID,
    }),
  },

  watch: {
    loaded: function(val) {
      if(val)
        this.commentText = '';
    }
  }
  
};
</script>

<style src="./TaskComments.scss" lang="scss" scoped />
